/*
 * formik Actions
 *
 * @version 1.0.0
 * @author Bartolo Amico
 * @since 23-Sep-2022
 */

import { createRequestTypes, createAction, MakeRequest } from './index';

export const actionTypes = {
  DO_SAVE_FORM: '@@formik/save_form',
  DO_SHOW_ERROR: '@@formik/show_error',
  DO_HIDE_ERROR: '@@formik/hide_error',
  // @generator action:type
  // @generator action:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action
 * * Insert a description
 * @name SaveForm
 * @return {object} - The payload object
 */
export const doSaveForm = payload => createAction(actionTypes.DO_SAVE_FORM, { payload });


/** @action
 * * Insert a description
 * @name ShowError
 * @return {object} - The payload object
 */
export const doShowError = payload => createAction(actionTypes.DO_SHOW_ERROR, { payload });


/** @action
 * * Insert a description
 * @name HideError
 * @return {object} - The payload object
 */
export const doHideError = payload => createAction(actionTypes.DO_HIDE_ERROR, { payload });

// @generator action
